import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getBlogPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/blog",
		[Locale.en]: "/blog",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
